import * as React from "react";
const SvgFiRrMehRollingEyes = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-meh-rolling-eyes_svg__a)">
      <path
        fill="#062147"
        d="M16.5 6c-4.612.129-4.611 7.872 0 8 4.612-.129 4.611-7.872 0-8m0 6c-1.114.045-1.833-1.743-1.352-2.85a1.514 1.514 0 0 0 2.7 0c.485 1.107-.234 2.895-1.348 2.85M11 10c-.128-5.278-6.872-5.277-7 0 .128 5.278 6.872 5.277 7 0m-5 0c0-.29.05-.578.148-.85a1.514 1.514 0 0 0 2.7 0C9.772 11.956 6.265 13.4 6 10m11 7a1 1 0 0 1-1 1H8a1 1 0 0 1 0-2h8a1 1 0 0 1 1 1M12 0A12.013 12.013 0 0 0 0 12c.6 15.9 23.4 15.894 24 0A12.013 12.013 0 0 0 12 0m0 22A10.01 10.01 0 0 1 2 12c.5-13.248 19.5-13.244 20 0a10.01 10.01 0 0 1-10 10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-meh-rolling-eyes_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMehRollingEyes;
